import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;
const DataList = ({ data, handleSort, getAllinvitedData }) => {
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              {/* <Th>ABN/NZBN</Th> */}
              <Th onClick={(e) => handleSort(e, "worker_name")}>
                <span className="flex items-center gap-1">
                  Worker
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "worker_name" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "provider_trading_name")}>
                <span className="flex items-center gap-1">
                  Provider connection
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "provider_trading_name" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              {/* <Th onClick={(e) => handleSort(e, "completion_date")}>
                <span className="flex items-center gap-1">
                  Clients assigned
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "completion_date" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th> */}
              <Th>Status</Th>
              {/* <Th>Reason</Th> */}
              {/* <Th>Worker type</Th> */}
              
              {/* <Th onClick={(e) => handleSort(e, "approval_date")}>
                <span className="flex items-center gap-1">
                  Approval date
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "approval_date" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "creation_date")}>
                <span className="flex items-center gap-1">
                  Creation date
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "creation_date" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th> */}
            </Tr>
          </THead>
          <TBody>
            {data?.workers?.length > 0 &&
              data?.workers?.map((item, index) => {
                const normalizedStatus =
                  item?.status === "Partial" ? "Non-Compliant" : item?.status;
                return (
                  <Tr key={index}>
                    {/* <Td>{item?.provider_abn_nzbn}</Td> */}
                    <Td>{item?.worker_name}</Td>
                    <Td>{item?.provider_trading_name}</Td>
                    {/* <Td>{item?.client_trading_name || "-"}</Td> */}
                    <Td>
                      {normalizedStatus != "No-clients" ? (
                        <span
                        className={
                          normalizedStatus == "Compliant"
                            ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                            : normalizedStatus == "Invited"
                              ? "badge text-gray-700 bg-gray-100 py-0.5 px-2 rounded-lg font-normal"
                              : " badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                        }
                      >
                          {normalizedStatus}
                        </span>
                      ) : (
                        "-"
                      )}
                    </Td>
                    {/* <Td>{item?.reason}</Td> */}
                    {/* <Td>{item?.worker_type}</Td> */}
                    {/* <Td>
                      {item?.approval_date
                        ? moment(item?.approval_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                    <Td>
                      {item?.creation_date
                        ? moment(item?.creation_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td> */}
                  </Tr>
                );
              })}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default DataList;
